import { useContext } from 'react';
import { usePlanUpdatedSubscription } from '../../../graphql/subscription/plan/planUpdatedSubscription';
import Context from '../../context';

export default function ContextPlanUpdatedSubscription() {
  const { refetchUserAndCompanyInfo } = useContext(Context);

  usePlanUpdatedSubscription(
    `
    updatedPlan {
      _id
    }
  `,
    {
      shouldResubscribe: true,
      onSubscriptionData: ({ subscriptionData }) => {
        if (
          subscriptionData &&
          subscriptionData.data &&
          subscriptionData.data.planUpdated &&
          subscriptionData.data.planUpdated.updatedPlan
        ) {
          refetchUserAndCompanyInfo();
        }
      },
    }
  );
  return null;
}
